import axios from 'axios';
import router from '@/router/index';
import { logout } from '@/services/auth';

const API_BASE_URL = 'https://semillero-api-v2.vercel.app/api';
const CACHE_VERSION = '1.5'; // Agregar versión de caché

// Limpiar caché antiguo si es necesario
const initializeCache = () => {
    const storedVersion = localStorage.getItem('cacheVersion');
    if (storedVersion !== CACHE_VERSION) {
        console.log('Nueva versión de caché detectada, limpiando caché antiguo...');
        // Agregar limpieza de caché de actividades
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('activities_') || key === 'activity_stats') {
                localStorage.removeItem(key);
                localStorage.removeItem(`${key}_timestamp`);
            }
        });
        // Limpiar todo el caché relacionado
        localStorage.removeItem('accessToken');
        localStorage.removeItem('products');
        localStorage.removeItem('productsTimestamp');
        localStorage.removeItem('userOrders');
        localStorage.removeItem('adminOrders');
        localStorage.removeItem('ordersTimestamp');
        localStorage.removeItem('userPermissions');
        localStorage.removeItem('userPermissionsTimestamp');
        // Establecer nueva versión
        localStorage.setItem('cacheVersion', CACHE_VERSION);
    }
};

// Ejecutar limpieza al iniciar
initializeCache();

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Interceptor para agregar el token a todas las peticiones
apiClient.interceptors.request.use(config => {
    const token = localStorage.getItem('accessToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

apiClient.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            // Limpiar todos los datos de autenticación
            logout();
            
            // Solo redirigir si no estamos ya en la página de login
            if (router.currentRoute.value.name !== 'LoginForm') {
                router.push({ 
                    name: 'LoginForm',
                    query: { redirect: router.currentRoute.value.fullPath }
                });
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;